import { RunsRollup } from '@/components/rollups/Rollups';
import { api } from '@/lib/api';
import { useWorkspaceCtx } from './WorkspaceLayout';

/** Every run in this engagement, newest first. */
export function WorkspaceActivityTab() {
  const { company, workspace } = useWorkspaceCtx();
  return (
    <RunsRollup
      fetchKey={`ws-${workspace.id}`}
      fetch={() => api.listWorkspaceRuns(workspace.id)}
      companySlug={company.slug}
    />
  );
}
